/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/jsx-no-undef */
import { Box, Grid, Popover, Typography } from '@material-ui/core';
import React from 'react';
import { moneyFormat } from './colorFormat';

export default function PackageItems({ pack, items, isRTL }: any) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'popover-language' : undefined;

  return (
    <>
      <Box
        onClick={handleClick}
        aria-describedby={id}
        p={0.5}
        style={{
          borderRadius: 15,
          backgroundColor: pack?.isred ? '#ffc0cbaa' : '#fafafa',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
        }}
      >
        <Typography variant="h5">{moneyFormat(pack.price)}</Typography>
        <Typography variant="h6">
          {isRTL ? pack?.name : pack?.nameAr}
        </Typography>
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: { borderRadius: 15, marginTop: 5 },
        }}
        style={{ direction: isRTL ? 'rtl' : 'ltr' }}
      >
        <Box style={{ margin: 15, width: 500 }}>
          <Grid spacing={1} container>
            <Grid item xs={6}>
              <Typography style={{ fontWeight: 'bold' }}>
                {isRTL ? 'اسم البند' : 'Item Name'}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>{isRTL ? 'السعر' : 'Price'}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>{isRTL ? 'المطلوب' : 'Require'}</Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography>{isRTL ? 'متوفر' : 'Available'}</Typography>
            </Grid>
            {items?.map((it: any) => {
              return (
                <>
                  <Grid
                    item
                    xs={6}
                    style={{
                      backgroundColor: it.isred ? '#ffc0cbaa' : undefined,
                    }}
                  >
                    <Typography>{isRTL ? it?.nameAr : it?.name}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    style={{
                      backgroundColor: it.isred ? '#ffc0cbaa' : undefined,
                    }}
                  >
                    <Typography>{moneyFormat(it.price)}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    style={{
                      backgroundColor: it.isred ? '#ffc0cbaa' : undefined,
                    }}
                  >
                    <Typography>{it.itemqty}</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    style={{
                      backgroundColor: it.isred ? '#ffc0cbaa' : undefined,
                    }}
                  >
                    <Typography>
                      {it?.itemType === 4 && it?.stock_qty}
                    </Typography>
                  </Grid>
                </>
              );
            })}
          </Grid>
        </Box>
      </Popover>
    </>
  );
}
